.content {
  width: 100%;
  padding: 1rem;
  overflow: hidden;
  background-color: white;
  border: 1px solid #e6e6e6;
}

.search {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  composes: slideDown from global;
}

.searchInputWrapper {
  width: 412px;
}

.scanButton {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 49px;
  width: 49px;
  padding: 0;
  border: 1px solid var(--color-neutral-400, #ccc);
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: inherit;
}

.scanButton:hover {
  background-color: var(--color-neutral-50, #f5f5f5);
}
